import {
  BagSearchPayload,
  IBagInfoData,
  IBagInformationData,
  IBagMiscellaneousData,
  IBagShipmentData,
  IBagShipmentListData,
} from 'src/app/features/model/bag.model';

// Miscellaneous Section
export class SaveBagMiscellaneous {
  static readonly type = '[Miscellaneous] Save';
  constructor(public payload: IBagMiscellaneousData) {}
}

export class ResetBagMiscellaneous {
  static readonly type = '[Miscellaneous] Reset';
}

//Piece table
export class LinkShipmentToBag {
  static readonly type = '[Shipment] Link';
  constructor(public payload: IBagShipmentData[]) {}
}

export class UnlinkShipmentFromBag {
  static readonly type = '[Shipment] Unlink';
  constructor(public payload: string) {}
}

export class ResetPieceList {
  static readonly type = '[Piece] Reset';
}


export class FetchBagsList {
  static readonly type = '[Bags] Summary List';
  constructor(public payload: BagSearchPayload) {}
}

export class ResetBagsList {
  static readonly type = '[Bags] Reset Summary List';
}
export class FetchBagsInformationListSuccess {
  static readonly type = '[Bag] Fetch Bags Information List Success';
  constructor(public bags: IBagInformationData[]) {}
}

export class FetchSelectedBagById {
  static readonly type = '[Bags] Fetch Selected Bag By Id';
  constructor(public bagId: number) {}
}

export class ResetBagsInformationList {
  static readonly type = '[Bags] Reset Bags Information List';
}

export class UpdateBagInformation {
  static readonly type = '[BagInformation] Update';
  constructor(public payload: IBagInfoData) {}
}

export class AddBagShipment {
  static readonly type = '[Shipment] Add Bag Shipment';
  constructor(public payload: IBagShipmentListData[]) {}
}
export class DeleteBagShipment {
  static readonly type = '[Shipment] Unlink Bag Shipment';
  constructor(public payload: any) {}
}
export class ResetBagShipmentList {
  static readonly type = '[Shipment] Reset Bag Shipment';
}

export class FetchBagDropdowns {
  static readonly type = '[Bags] Fetch Dropdowns';
  constructor(public payload: any) {}
}